const BASE_URL = import.meta.env.VITE_CONFIG_API_URL?.replace(/\/$/, '') ?? '';
const ARTICLE_IMAGE_PATH = '/artikel-afbeelding';

const escapeRegex = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const resolveArticleImageUrls = (body?: string) => {
  if (!body) {
    return body;
  }

  return body.replace(
    /(src=["'])\/artikel-afbeelding\/(\d+)(["'])/gi,
    `$1${BASE_URL}${ARTICLE_IMAGE_PATH}/$2$3`
  );
};

export const normalizeArticleImageUrls = (body?: string) => {
  if (!body || !BASE_URL) {
    return body;
  }

  const baseUrlRegex = new RegExp(`${escapeRegex(BASE_URL)}${ARTICLE_IMAGE_PATH}/(\\d+)`, 'gi');
  return body.replace(baseUrlRegex, `${ARTICLE_IMAGE_PATH}/$1`);
};
